export default {
  install: function (Vue, options) {
    Vue.prototype.$getRole = options.role;
  }
};